import { Text } from 'native-base'

const MobileOrientation = () => {
  return <Text>Mobile Orientation</Text>
}

export default MobileOrientation
